import React, { PureComponent } from 'react'
import { string, arrayOf, shape, oneOf } from 'prop-types'
import { capitalize } from 'utils/string'

export class TableLegend extends PureComponent {
    static propTypes = {
        items: arrayOf(
            shape({
                color: oneOf(['red', 'green', 'yellow', 'black']),
                text: string.isRequired
            })
        ).isRequired
    }

    renderItem = ({ color, text }) => <div key={color} className={capitalize(color)}>{text}</div>
    render() {
        const { items } = this.props
        return (
            <div className="TableLegend">
                {items.map(this.renderItem)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Table/TableLegend.js